import AppRoutes from 'Components/AppRoutes';
import { ThemeProvider } from '@emotion/react';
import { CssBaseline } from '@mui/material';
import { useEffect } from 'react';
import { securityClient } from 'securityClient';
import { useAppDispatch } from 'State/hooks';
import { setCompany } from 'State/companySlice';
import { ColorModeContext, useMode } from 'theme';
function App() {
  const { theme, colorMode } = useMode();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (localStorage.getItem('idToken')) {
      securityClient.setAccessTokenSilently(async () => localStorage.getItem('idToken') ?? '');
    }
    const localCompanyId = localStorage.getItem('companyId');
    if (localCompanyId) {
      dispatch(setCompany(localCompanyId));
    }
  }, [dispatch]);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          <main className="content">
            <AppRoutes />
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
